import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

export interface HeaderIconLinkProps {
  to: string;
  label: string;
  icon: LucideIcon;
  count?: number;
}

/** Cart/wishlist icon buttons in the header -- a small numeric badge overlays the icon whenever `count > 0`. */
export function HeaderIconLink({ to, label, icon: Icon, count = 0 }: HeaderIconLinkProps) {
  return (
    <Link
      to={to}
      aria-label={count > 0 ? `${label} (${count} items)` : label}
      className="focus-visible:ring-brand relative flex h-9 w-9 items-center justify-center rounded-full text-gray-700 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2"
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
      {count > 0 && (
        <span className="bg-brand text-brand-foreground absolute -right-1 -top-1 flex h-4 min-w-[1rem] items-center justify-center rounded-full px-1 text-[10px] font-bold">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  );
}
